import React, { ChangeEvent, ChangeEventHandler } from "react";
import { TextFieldProps, Theme } from "@mui/material";

import { getMessage, initToast } from "../../shared/helper-functions";
import { useAppSelector } from "../../../redux/store";
import { StandardTextField } from "./styled/standard";
import { MessageSections } from "../message/message";
import { OrderSearch } from "./styled/orders";

const BarekamInput = ({
  customInputVariant,
  width,
  error,
  errorMessage,
  placeholder,
  value,
  isReadonly,
  height,
  onChange,
  validatePattern = false,
  validNumber = false,
  ...props
}: BarekamInputProps) => {
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );
  let count = 1;
  const changeHandle = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    const val = e.target.value;
    if (validatePattern) {
      const latinOnly = val?.search(/[^a-zA-Z0-9\s.,!?@#$%^&*()_+\-=]/g) as any;

      const message = getMessage(
        "only_latin_letters",
        MessageSections.MAIN,
        messageCache,
        languageId,
      );

      if (latinOnly !== -1) {
        count === 1 && initToast(message, "error");
        count++;
        return;
      }
    }
    if(validNumber) {
      if (!/^(0|[1-9]\d*)(\.\d*)?$|^(\.\d+)?$/.test(val)) {
        return
      }
    }
    onChange && onChange(e);
  };

  switch (customInputVariant) {
    case "standard":
      return (
        <StandardTextField
          {...props}
          value={value || ""}
          error={error}
          label={placeholder}
          helperText={errorMessage}
          style={{
            marginBottom: error ? "1rem" : "unset",
            width: width || "unset",
            height: height || "3.5rem",
          }}
          disabled={isReadonly}
          variant="outlined"
          onChange={changeHandle}
        />
      );
    case "search":
      return (
        <OrderSearch
          {...props}
          value={value || ""}
          placeholder={placeholder}
          onChange={changeHandle}
          style={{ width: width || "unset" }}
          size={"small"}
        />
      );
    default:
      return null;
  }
};

export default BarekamInput;

interface BarekamInputProps extends TextFieldProps<"standard"> {
  customInputVariant: "standard" | "search";
  value: string | number | null | undefined;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  children?: React.ReactNode;
  isReadonly?: boolean;
  multiline?: boolean;
  theme?: Theme;
  errorMessage?: string;
  width?: string;
  height?: string;
  validatePattern?: boolean;
  validNumber?: boolean;
}
